@if (user(); as u) {
  <div class="bar">
    @if (!isHome()) {
      <a routerLink="/" class="home-link">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        Strona główna
      </a>
    }

    <a routerLink="/admin/moje-quizy" class="quizzes-link">Moje quizy</a>
    <span class="sep">|</span>

    <button (click)="login.signOut()" title="Wyloguj się" class="logout">
      <span>Wyloguj</span>
      @if (u.photoURL) {
        <img [src]="u.photoURL" [alt]="u.displayName || ''" width="26" height="26" class="avatar" referrerpolicy="no-referrer" />
      } @else {
        <span class="avatar-fallback">{{ u.displayName?.[0] ?? '?' }}</span>
      }
    </button>
  </div>
}
